const BaseView = require('../components/common/common-component');
const AnalyticsDecorate = require('../../../analytics/decorate');
const CompanyFactory = require('../../../factory/company').instance;

module.exports = AnalyticsDecorate(require('./analytics/view'), BaseView.extend({
  type: 'icon',
  memberType: ['logos'],
  uploadViewKey: 'icons-import',
  StockView: require('./stock'),
  categories: null,

  isAlreadyThere: function () {
    return !!this.$el.find('.tab-content.icon').length;
  },

  render: async function () {
    await BaseView.prototype.render.call(this);

    const features = await CompanyFactory.getCompanyItems('features');
    const $stockTab = this.$headerLinks.filter('[data-key=stock]');

    const hasStockTab = $stockTab.length > 0;
    const isStockElementEnabled = !!features?.white_label?.includes?.('show_stock_elements') && hasStockTab;

    !isStockElementEnabled && $stockTab.addClass('hidden');

    const $startTab = isStockElementEnabled
      ? $stockTab
      : this.$headerLinks.filter('[data-key=library], [data-key=user_library]');

    $startTab.length && !this.isEnterprise
      ? $startTab.trigger('click')
      : BaseView.prototype.checkEmptyLibrary.call(this, $startTab);
  },

  updateSearchContainer: function () {
    if (this.selectedTab.key === 'add') {
      this.selectedTab.searchable = false;
    }

    this.selectedTab.searchable && this.displaySearchContainer(this.$el.find('.search-container'));
  }
}));
